export default __webpack_public_path__ + "images/hot-orange-60.png";